// extracted by mini-css-extract-plugin
module.exports = {"knob":"KnobMove_knob_2ho35"};